module.exports = __webpack_public_path__ + "media/ting.073da492.mp3";